<template>
  <el-dialog title="选择地址" :visible.sync="isShowDialog" :width="width" top="50px" :destroy-on-close="false">
    <div class="map-box" :style="{ width: '100%', height: height }">
      <div id="amap" ref="map" class="amap"></div>
      <div class="detail">
        <el-select
          v-model="keyword"
          style="width: 100%;"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          :loading="loading"
          @change="onChange"
        >
          <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
        <p>经度：{{ point ? point[0] : '-' }}</p>
        <p>纬度：{{ point ? point[1] : '-' }}</p>
        <p>地址：{{ address }}</p>
        <button size="mini" class="btnmap" @click="commit">确定</button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '1100px' }
  },
  data() {
    return {
      amap: null,
      isShowDialog: false,
      height: '500px',
      address: '',
      point: [],
      markers: [],
      map: '',
      options: [],
      loading: false,
      markerLayer: null,
      lat: 39.90961955588804,
      lng: 116.39632735411737,
      keyword: ''
    }
  },
  mounted() {
    // this.showMap()
  },
  methods: {
    show(lng, lat, address) {
      if (lng && lat && address) {
        this.point = [lng, lat]
        this.lat = lat
        this.lng = lng
        this.address = address
      } else {
        this.point = [this.lng, this.lat]
        this.getAddress(this.lat, this.lng)
      }
      this.isShowDialog = true
      this.$nextTick(() => {
        if (!this.amap) {
          this.init()
        }
      })
    },
    // 初始化
    init() {
      // 地图主类
      this.amap = new TMap.Map(this.$refs.map, {
        center: new TMap.LatLng(this.lat, this.lng)
      })

      // 初始化marker图层
      this.markerLayer = new TMap.MultiMarker({
        id: 'marker-layer',
        map: this.amap,
        geometries: [
          {
            position: new TMap.LatLng(this.lat, this.lng),
            id: 'marker'
          }
        ]
      })

      this.amap.on('click', evt => {
        const { lat, lng } = evt.latLng
        this.markerLayer.setGeometries([])
        this.markerLayer.add({
          position: evt.latLng
        })
        this.amap.setCenter(new TMap.LatLng(lat, lng))
        this.point = [lng, lat]
        this.lat = lat
        this.lng = lng
        this.getAddress(lat, lng)
      })

      this.amap.on('mouseup', e => {
        const { lat, lng } = this.amap.getCenter()
        this.amap.setCenter(new TMap.LatLng(lat, lng))
      })
    },
    currentPosition(map, lnglat) {
      if (lnglat) {
        // 有传入坐标点，直接定位到坐标点
        map.setCenter(lnglat)
        this.addMark(map, lnglat)

        // 获取地址
        this.getAddress(lnglat)
      }
    },

    search(keyword) {
      const search = new TMap.service.Search({
        pageSize: 10
      })
      search.searchRegion({
        keyword: keyword,
        autoExtend: true
      }).then(res => {
        this.options = res.data
        this.loading = false
      })
    },

    // 添加标记
    addMark(map, points) {
      const marker = new AMap.Marker({
        map: map,
        position: points,
        draggable: true, // 允许拖动
        cursor: 'move',
        raiseOnDrag: true
      })
      this.markers.push(marker)
      const position = marker.getPosition()
      // 存下坐标与地址
      this.point = [position.lng, position.lat]
      this.getAddress([position.lat, position.lng])
      // marker.on('dragend', (e) => {
      //   const position = marker.getPosition()

      //   // 存下坐标与地址
      //   this.point = [position.lng, position.lat]
      //   this.getAddress([position.lng, position.lat])
      // })
    },

    // 根据坐标返回地址(逆地理编码)
    getAddress(lat, lng) {
      const points = new TMap.LatLng(lat, lng)
      const geocoder = new TMap.service.Geocoder()
      geocoder.getAddress({ location: points }) // 将给定的坐标位置转换为地址
        .then((result) => {
          this.address = result.result.address
          // 显示搜索到的地址
        })
    },

    commit() {
      if (this.point.length === 0) {
        this.$message({
          message: '请选择地址',
          type: 'error'
        })
        return
      }
      this.isShowDialog = false
      this.$emit('location', this.point, this.address, this.name)
    },

    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        this.search(query)
      } else {
        this.options = []
      }
    },

    onChange(e) {
      const obj = this.options.find(v => v.id === e)
      // const { location: { lat, lng }, title } = obj
      const { location: { lat, lng }} = obj
      this.point = [lng, lat]
      this.lat = lat
      this.lng = lng
      // this.address = title
      this.markerLayer.setGeometries([])
      this.markerLayer.add({
        position: obj.location
      })
      this.amap.setCenter(new TMap.LatLng(this.lat, this.lng))
      // 获取地址
      this.getAddress(lat, lng)
    }
  }
}
</script>

<style lang="scss" scoped>
.map-box {
  box-sizing: border-box;
  background-color: #ddd;
  padding: 15px;

  &:after {
    content: '';
    display: block;
    clear: both;
  }

  .amap,
  .detail {
    float: left;
    height: 100%;
  }

  .amap {
    width: 68%;
  }

  .detail {
    width: 32%;
    background-color: #fff;
    padding: 15px 15px 0 15px;
    border-left: 1px solid #eee;
    box-sizing: border-box;
    word-wrap: break-word;

    p {
      font-size: 14px;
      margin: 10px 0;
    }
  }

  .btnmap {
    width: 100%;
    margin: 30px 0 0 0;
    padding: 5px 0;
    color: #fff;
    cursor: pointer;
    background-color: #409eff;
    border: none;
    border-radius: 3px;

    &:hover {
      background-color: #66b1ff;
    }
  }
}

.dialog {
  z-index: 1000 !important;
}
</style>
